const cnpjMask = [
  /[0-9]/,
  /[0-9]/,
  '.',
  /[0-9]/,
  /[0-9]/,
  /[0-9]/,
  '.',
  /[0-9]/,
  /[0-9]/,
  /[0-9]/,
  '/',
  /[0-9]/,
  /[0-9]/,
  /[0-9]/,
  /[0-9]/,
  '-',
  /[0-9]/,
  /[0-9]/
];

export const emptyTabelaPrecoClienteForm = {
  id: '',
  nome: '',
  cnpjCliente: '',
  tipoOperacao: '',
  idTabelaPrecoDeposito: ''
};

export const tabelaPrecoClienteFormStructure = [
  [
    {
      name: 'id',
      label: 'Id',
      component: 'FormField',
      type: 'number',
      colProps: { md: 2 },
      readOnly: true,
      disabled: true
    },
    {
      name: 'nome',
      label: 'Nome',
      placeholder: 'Digite o nome',
      component: 'FormField',
      type: 'text',
      colProps: { md: 4 },
      maxLength: 255
    },
    {
      name: 'cnpjCliente',
      label: 'CNPJ',
      placeholder: 'Digite o CNPJ',
      component: 'MaskedInput',
      type: 'text',
      colProps: { md: 3 },
      mask: cnpjMask,
      guide: false
    },
    {
      name: 'tipoOperacao',
      label: 'Tipo Operacao',
      placeholder: 'Digite o tipo de operacao',
      component: 'FormField',
      type: 'text',
      colProps: { md: 3 },
      maxLength: 255
    }
  ]
];

export const tabelaPrecoClienteFormSections = () => [
  { title: 'Clientes', rows: [0] }
];
